"use strict";

let $place_bg = $('.block_place .block__bg-wrap');

if ($place_bg.length && window.innerWidth < 1000) {
    $place_bg.animate({scrollLeft : ($place_bg.find('.block__bg').width() - $place_bg.width()) / 2}, 0);
}

$(document).on('click', '.header-mobile-menu__link', function (e) {
    e.preventDefault();

    $('.header').toggleClass('open');

    return false;
});

$(document).on('click', '.transport-zoom-btn', function (e) {
    e.preventDefault();

    let $block = $(this).closest('.block_transport'),
        $img = $block.find('.block__bg'),
        opened = $block.hasClass('open');

    $block
        .toggleClass('open')
        .animate({scrollTop : (opened ? 0 : ($img.height() - $block.height()) / 2)}, 0)
        .animate({scrollLeft : (opened ? 0 : ($img.width() - $block.width()) / 2)}, 0);

    return false;
});


// WEBPACK FOOTER //
// ./src/js/modules/common.js